
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ImmersiveHeroSection from './components/ImmersiveHeroSection';
import ImmersiveContentSection from './components/ImmersiveContentSection';

export default function Immersive() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <ImmersiveHeroSection />
        <ImmersiveContentSection />
      </main>
      <Footer />
    </div>
  );
}
